module.exports = __webpack_public_path__ + "static/media/lottery-prizes-mobile-big@2x.5505dd46.png";